import React, { useState } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';

const Header = ({ username }) => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <HeaderWrapper menu={showMenu}>
      <Hamburger onClick={toggleMenu}><span>&#9776;</span></Hamburger>
      <HeaderLeftElements showMenu={showMenu}>
        <HeaderElements>
          <NavLink to='/'>Servers</NavLink>
          <Dropdown>
            <DropdownItem to={'/servers/?category=Survival'}>Survival Severs</DropdownItem>
            <DropdownItem to={'/servers/?category=SkyBlock'}>Skyblock Severs</DropdownItem>
            <DropdownItem to={'/servers/?category=Prison'}>Prison Servers</DropdownItem>
            <DropdownItem to={'/servers/?category=Faction'}>Faction Servers</DropdownItem>
            <DropdownItem to={'/servers/?category=Bedwars'}>Bedwars</DropdownItem>
            <DropdownItem to={'/servers/?category=Minigames'}>Minigames</DropdownItem>
            <DropdownItem to={'/servers/?category=RPG'}>RPG</DropdownItem>
            <DropdownItem to={'/servers/?category=Anarchy'}>Anarchy</DropdownItem>
            <DropdownItem to={'/servers/?category=Practice'}>Practice</DropdownItem>
            <DropdownItem to={'/servers/?category=Touny'}>Touny</DropdownItem>
            <DropdownItem to={'/servers/?category=Modded'}>Modded</DropdownItem>
            <DropdownItem to={'/servers/?category=Cobblemon'}>Cobblemon</DropdownItem>
            <DropdownItem to={'/servers/?category=Skywars'}>Skywars</DropdownItem>
            <DropdownItem to={'/servers/?category=Lifesteal'}>Lifesteal</DropdownItem>
            <DropdownItem to={'/servers/?category=Earth'}>Earth</DropdownItem>
            <DropdownItem to={'/servers/?category=PVE'}>PVE</DropdownItem>
            <DropdownItem to={'/servers/?category=Parkour'}>Parkour</DropdownItem>
            <DropdownItem to={'/servers/?category=OneBlock'}>OneBlock</DropdownItem>
            <DropdownItem to={'/servers/?category=Pixelmon'}>Pixelmon</DropdownItem>
          </Dropdown>
        </HeaderElements>
        <HeaderElements>
          <NavLink to='/get-featured'>Get Featured</NavLink>
        </HeaderElements>
      </HeaderLeftElements>
      <HeaderTitle>
        <NavLink to={'/'}><img src='/assets/Logo.png' alt='Logo' /></NavLink>
      </HeaderTitle>
      <HeaderRightElements showMenu={showMenu}>
        <HeaderElements><NavLink to={'/servers/my-servers'} onClick={toggleMenu}>My Servers</NavLink></HeaderElements>
        <HeaderButton>
          {
            username !== '' ? <NavLink onClick={() => {
              Cookies.remove('msl_ui_tok_id');
              Cookies.remove('msl-uid-dta');
              window.location.reload();
            }}>LOG OUT</NavLink> : <NavLink to='/auth/signIn' onClick={toggleMenu}>SIGN IN</NavLink>
          }
        </HeaderButton>
      </HeaderRightElements>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.section`
  background-color: #fff;
  display: flex;
  padding: 1rem;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  box-shadow: 1px -4px 9px 1px #27800d;

  @media (max-width: 768px) {
    flex-direction: ${props => props.menu ? 'column' : 'row-reverse'};
    justify-content: space-evenly;
  }
`;

const HeaderTitle = styled.section`
  font-size: 4rem;

  img {
    width: 10rem;
  }

  a {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
      color: #3BA61C;
      font-weight: 500; 
    }
    color: #58678C;
    font-weight: 500;
  }

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    a {
      font-size: 3rem;
    }
  }
`;

const HeaderElements = styled.section`
  font-size: 2rem;
  color: #58678C;
  font-weight: 400;
  position: relative;

  a {
    color: #58678C;
    font-weight: 400;
    font-size: 2.5rem;

    &:hover {
      color: #3BA61C;
    }
  }

  &:hover > div {
    display: block;
  }

  @media (max-width: 768px) {
    width: 100%;

    a {
      color: #fff;
      background-color: #3BA61C;
      display: flex;
      justify-content: center;
      padding: 5px;

      &:hover {
        color: #fff;
      }
    }

    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    color: #fff;
    background-color: #3BA61C;
    display: flex;
    justify-content: center;
    padding: 5px;
    font-size: 3rem;

    &:hover {
      color: #fff;
    }
  }
`;

const Dropdown = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  height: 45rem;
  overflow-y: auto;
  z-index: 1;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const DropdownItem = styled(NavLink)`
  color: #58678C;
  padding: 12px 16px;
  display: block;
  white-space: nowrap;
  padding: 5px;

  &:hover {
    background-color: #3BA61C;
    color: #fff !important;
  }
`;

const HeaderButton = styled.section`
  font-size: 2rem;

  a {
    color: #58678C;
    font-weight: 430;

    &:hover {
      color: #3BA61C;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    a {
      color: #fff;
      background-color: #58678C;
      display: flex;
      justify-content: center;
      padding: 10px;

      &:hover {
        color: #fff;
      }
    }
  }
`;

const HeaderLeftElements = styled.section`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 768px) {
    width: 100%;
    display: ${props => props.showMenu ? 'flex' : 'none'};
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const HeaderRightElements = styled.section`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 768px) {
    width: 100%;
    display: ${props => props.showMenu ? 'flex' : 'none'};
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    text-align: center;
  }
`;

const Hamburger = styled.div`
  font-size: 3rem;
  cursor: pointer;

  span {
    color: #58678C;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

export default Header;
